import './App.css'

import { useCallback, useEffect, useState } from 'react'
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom'

import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import HeaderContainer from './components/_shared/header/HeaderComponent'
import LogIn from './containers/Authorization/components/login/LogIn'
import authorizationActions from './containers/Authorization/services/authorization-actions'
import DashboardPage from './containers/Dashboard/DashboardPage'
import DeviceDetailsPage from './containers/Devices/components/Details/components/DeviceDetailsPage'
import EditDevicePage from './containers/Devices/components/Details/components/editDevice/EditDevicePage'
import DevicesPage from './containers/Devices/components/List/DevicesPage'
import EmulatorPage from './containers/Emulator/EmulatorPage'
import EventsEmulator from './containers/EventsEmulator/EventsEmulatorContainer'
import FailedDevicesPage from './containers/FailedDevices/FailedDevicesPage'
import FeatureTogglingPage from './containers/FeatureToggling/FeatureTogglingPage'
import CreateFirmwarePage from './containers/Firmwares/components/createFirmware/CreateFirmwarePage'
import FirmwaresTableContainer from './containers/Firmwares/components/firmwaresTable/FirmwaresTableContainer'
import FirmwaresPage from './containers/Firmwares/FirmwaresPage'
import FirmwareUpdateSchedulePage from './containers/FirmwareUpdateSchedule/FirmwareUpdateSchedulePage'
import AddOrganizationPage from './containers/Organizations/components/addOrganization/AddOrganizationPage'
import ChangeAccountOwnerPage from './containers/Organizations/components/changeAccountOwner/ChangeAccountOwnerPage'
import OrganizationDetails from './containers/Organizations/components/Details/OrganizationDetails'
import OrganizationsPage from './containers/Organizations/OrganizationsPage'
import UsersPage from './containers/Users/UsersPage'
import { HttpClient } from './services/HttpClient'
import styles from './style'

const UNAUTHORIZED_HANDLER_EXCLUDED_URLS = [
  '/api/public/login/magic-link',
  '/api/public/login/verify',
]

const App = (props) => {
  const [isLogged, setIsLogged] = useState(HttpClient.tp.isLoggedIn())
  const { classes, logout } = props

  const listener = useCallback(
    (newIsLogged) => {
      setIsLogged(newIsLogged)
    },
    [setIsLogged]
  )

  useEffect(() => {
    HttpClient.setUnauthorizedHandler(() => {
      logout()
    }, UNAUTHORIZED_HANDLER_EXCLUDED_URLS)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    HttpClient.tp.subscribe(listener)

    return () => {
      HttpClient.tp.unsubscribe(listener)
    }
  }, [listener])

  return (
    <HashRouter>
      {isLogged && <HeaderContainer />}
      {isLogged && (
        <div className={classes.pageContainer}>
          <Switch>
            <Redirect exact from="/" to="/dashboard" />
            <Route
              path="/dashboard"
              component={(props) => <DashboardPage {...props} />}
            />
            <Route
              exact
              path="/organizations"
              component={(props) => <OrganizationsPage {...props} />}
            />
            <Route
              path="/organizations/changeOwner/:id"
              component={(props) => <ChangeAccountOwnerPage {...props} />}
            />
            <Route
              path="/organizations/add"
              component={(props) => <AddOrganizationPage {...props} />}
            />
            <Route
              path="/organizations/details/:id"
              component={(props) => <OrganizationDetails {...props} />}
            />
            <Route
              path="/device/sendCommand"
              component={(props) => <EmulatorPage {...props} />}
            />
            <Route
              path="/device/sendMessage"
              component={(props) => <EventsEmulator {...props} />}
            />
            <Route
              path="/defaultFirmwares"
              exact
              component={(props) => <FirmwaresPage {...props} />}
            />
            <Route
              path="/firmwares"
              exact
              component={(props) => <FirmwaresTableContainer {...props} />}
            />
            <Route
              path="/firmwares/createFirmware"
              component={(props) => (
                <CreateFirmwarePage {...props} isWriteOnly={true} />
              )}
            />
            <Route
              exact
              path="/devices"
              component={(props) => <DevicesPage {...props} />}
            />
            <Route
              exact
              path="/devices/bulk/fails"
              component={(props) => <FailedDevicesPage {...props} />}
            />
            <Route
              path="/devices/details/:imei/:serialNumber/:id"
              component={(props) => <DeviceDetailsPage {...props} />}
            />
            <Route
              path="/devices/edit/:deviceType/:id"
              component={(props) => <EditDevicePage {...props} />}
            />
            <Route
              path="/firmware-update/schedule"
              component={(props) => <FirmwareUpdateSchedulePage {...props} />}
            />
            <Route
              path="/users"
              component={(props) => <UsersPage {...props} />}
            />
            <Route
              path="/feature/toggling"
              component={(props) => <FeatureTogglingPage {...props} />}
            />
            <Redirect to="/dashboard" push />
          </Switch>
        </div>
      )}
      {!isLogged && (
        <div className={classes.authWrapper}>
          <Switch>
            <Redirect exact from="/" to="/login" />
            <Route path="/login" component={(props) => <LogIn {...props} />} />
            <Redirect to="/login" push />
          </Switch>
        </div>
      )}
    </HashRouter>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(authorizationActions.logout()),
  }
}

export default connect(null, mapDispatchToProps)(withStyles(styles)(App))
